import React, { useEffect, useState } from "react";
import Sidebar from "../Components/Sidebar";
import Header from "../Components/Header";
import { Contact_Us } from "../Configuration/API_URL";
import Loader from "../Components/Common/Loader";
import { noDataFound } from "../CommonMethhods/CommonMethods";
import SingleSignOnSideBar from "../Components/SingleSignOnSideBar";
import axiosInstance from "../CommonMethhods/axiosInstance";

function ContactUs() {
  const storeToken = localStorage.getItem("ssoToken");
  const [serverError, setServerError] = useState(false);
  const [detail, setDetail] = useState([]);
  const [loader, setLoader] = useState(false);
  const [errorData, setErrorData] = useState(false);

  const getQueriesDetail = async () => {
    setLoader(true);
    try {
      const getDetail = await axiosInstance.get(
        Contact_Us.Contact_Us_URL,
      );
      const res = getDetail?.data;
      if (res?.status === 0) {
        setDetail(res?.data);
        setServerError(false);
      } else {
        setErrorData(res?.message);
      }
    } catch (error) {
      console.log(error);
      setDetail([]);
      setErrorData(false);
      setServerError(error.message);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    getQueriesDetail();
  }, []);

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content">
        <div className="card-box ">
          <div className="card-title">
            <h2 className="h2-css-all">Contact Details for Queries</h2>
          </div>
          <div className="card-contnent">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : detail && detail.length > 0 ? (
              detail.map((value, index) => {
                const { contactNumber, email } = value;
                const NumberArray = contactNumber.split(",");
                return (
                  <div className="main-box-width">
                    <div className="main-row">
                      <div className="left-contact">
                        <ul>
                          {NumberArray.map((value, index) => (
                            <div className="d-flex">
                              <span className="icon-phone-icon"></span>
                              <li key={index} className="mb-3">
                                {value}
                              </li>
                            </div>
                          ))}
                        </ul>
                      </div>
                      <div className="right-email">
                        <span className="icon-email" />
                        {email}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : serverError ? (
              noDataFound(serverError)
            ) : (
              errorData && noDataFound()
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default ContactUs;
